AFRAME.registerComponent('tablerow', {
  schema: {
    // y: {default: 1.0},
    zSpacing: {default: 2.0},
    count: {default: 1},
  },

  update: function () {
    const object = this.el.object3D;

    const legMaterial = new THREE.MeshBasicMaterial({color: "#a8a8a8"});
    const topMaterial = new THREE.MeshBasicMaterial({color: "#383838"});
    const legGeometry = new THREE.BoxGeometry(0.03, 1, 0.03);
    const topGeometry = new THREE.BoxGeometry(0.77, 0.05, 1.35);

    const legsGeometry = new THREE.Geometry();
    const topsGeometry = new THREE.Geometry();

    for (let i=0; i<this.data.count; ++i) {
      const leg1 = new THREE.Mesh(legGeometry, legMaterial);
      leg1.position.x = -0.3;
      leg1.position.y = -0.5;
      leg1.position.z = i * this.data.zSpacing + 0.6;
      leg1.updateMatrix();

      const leg2 = new THREE.Mesh(legGeometry, legMaterial);
      leg2.position.x = -0.3;
      leg2.position.y = -0.5;
      leg2.position.z = i * this.data.zSpacing + -0.6;
      leg2.updateMatrix();

      const leg3 = new THREE.Mesh(legGeometry, legMaterial);
      leg3.position.x = 0.3;
      leg3.position.y = -0.5;
      leg3.position.z = i * this.data.zSpacing + 0.6;
      leg3.updateMatrix();

      const leg4 = new THREE.Mesh(legGeometry, legMaterial);
      leg4.position.x = 0.3;
      leg4.position.y = -0.5;
      leg4.position.z = i * this.data.zSpacing + -0.6;
      leg4.updateMatrix();

      legsGeometry.merge(leg1.geometry, leg1.matrix);
      legsGeometry.merge(leg2.geometry, leg2.matrix);
      legsGeometry.merge(leg3.geometry, leg3.matrix);
      legsGeometry.merge(leg4.geometry, leg4.matrix);


      const top = new THREE.Mesh(topGeometry, topMaterial);
      top.position.x = 0;
      top.position.y = 0;
      top.position.z = i * this.data.zSpacing + 0;
      top.updateMatrix();

      topsGeometry.merge(top.geometry, top.matrix);
    }

    const legMesh = new THREE.Mesh(legsGeometry, legMaterial);

    const topMesh = new THREE.Mesh(topsGeometry, topMaterial);

    object.add(legMesh);
    object.add(topMesh);
  },
});
